// Shared page-title primitive. Standardizes the h1 typography across every
// route — was previously inconsistent (font-semibold on older routes,
// font-bold on newer, no explicit color on some). One component to govern
// them all + a single place to evolve the brand-level page-title style.

import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Optional element to align to the right side of the title (e.g. a button). */
  right?: ReactNode;
  className?: string;
}

export default function PageTitle({ children, right, className = "" }: Props) {
  return (
    <div className={`flex items-baseline justify-between gap-3 ${className}`}>
      <h1 className="text-2xl font-bold text-slate-100 tracking-tight">{children}</h1>
      {right}
    </div>
  );
}
